import { IconButton } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useResponsive from "src/hooks/useResponsive";

import Context from "../context";

// ----------------------------------------------------------------------

export const CrossExitBtn = () => {
	const { values } = useContext(Context);

	const isMobile = useResponsive("down", "sm");

	return (
		<IconButton
			sx={{
				position: "absolute",
				right: 0,
				mr: 4,
				backgroundColor: values?.contentBackgroundColor,
				boxShadow: 1,
				p: 0.8
			}}
		>
			<Iconify
				icon={"gridicons:cross"}
				color={values?.primaryTextColor}
				width={isMobile ? 14 : 16}
			/>
		</IconButton>
	);
};

export default CrossExitBtn;
